import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-328e1a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pptist-editor" }
const _hoisted_2 = { class: "layout-content" }
const _hoisted_3 = { class: "layout-content-center" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import useGlobalHotkey from '@/hooks/useGlobalHotkey'
import usePasteEvent from '@/hooks/usePasteEvent'

import EditorHeader from './EditorHeader/index.vue'
import Canvas from './Canvas/index.vue'
import CanvasTool from './CanvasTool/index.vue'
import Thumbnails from './Thumbnails/index.vue'
import Toolbar from './Toolbar/index.vue'
import Remark from './Remark/index.vue'
import ExportDialog from './ExportDialog/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mainStore = useMainStore()
const { dialogForExport } = storeToRefs(mainStore)
const closeExportDialog = () => mainStore.setDialogForExport('')

const remarkHeight = ref(40)

useGlobalHotkey()
usePasteEvent()

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(EditorHeader, { class: "layout-header" }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Thumbnails, { class: "layout-content-left" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(CanvasTool, { class: "center-top" }),
          _createVNode(Canvas, {
            class: "center-body",
            style: _normalizeStyle({ height: `calc(100% - ${remarkHeight.value + 40}px)` })
          }, null, 8, ["style"]),
          _createVNode(Remark, {
            class: "center-bottom",
            height: remarkHeight.value,
            "onUpdate:height": _cache[0] || (_cache[0] = ($event: any) => ((remarkHeight).value = $event)),
            style: _normalizeStyle({ height: `${remarkHeight.value}px` })
          }, null, 8, ["height", "style"])
        ]),
        _createVNode(Toolbar, { class: "layout-content-right" })
      ])
    ]),
    _createVNode(_component_Modal, {
      visible: !!_unref(dialogForExport),
      footer: null,
      centered: "",
      closable: false,
      width: 680,
      destroyOnClose: "",
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (closeExportDialog()))
    }, {
      default: _withCtx(() => [
        _createVNode(ExportDialog)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})